import { Checkbox, TableCell } from "@mui/material";
import { format } from "date-fns";
import { formatCurrency } from "../../../../Utils/formatters";
import {
  CustomTableRow,
} from "../styles";

interface InvoiceRowDuplicatesProps {
  duplicate: any;
  limitPerInvoice: number;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const InvoiceRowDuplicates = ({ duplicate, limitPerInvoice, checked, onChange }: InvoiceRowDuplicatesProps) => {
  return (
    <>
      <CustomTableRow>
        <TableCell>
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
          />
        </TableCell>
        <TableCell>{formatCurrency(duplicate.amount, "BRL", 0)}</TableCell>
        <TableCell>{formatCurrency(duplicate.netAmount, "BRL", 0)}</TableCell>
        <TableCell>{formatCurrency(duplicate.rate, "BRL", 0)}</TableCell>
        <TableCell>{formatCurrency(duplicate.receivableAmount, "BRL", 0)}</TableCell>
        <TableCell>
          {duplicate.previsionDate
            ? format(new Date(duplicate.previsionDate), "dd/MM/yyyy")
            : "-"}</TableCell>
      </CustomTableRow>
    </>
  );
};
